var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"como-hacemos"},[_c('h4',[_vm._v(" ¿Que tenemos para ofrecerte? ")]),_c('iframe',{attrs:{"width":"560","height":"315","src":"https://www.youtube.com/watch?v=_Tcxk0wthYE","title":"Video de ComercioCity","loading":"lazy","frameborder":"0","allowfullscreen":""}})])
}]

export { render, staticRenderFns }